module.exports = __webpack_public_path__ + "static/media/logo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.svg
// module id = 44
// module chunks = 0